import { SafePaddingContainer } from "@/components/SafePaddingContainer";
import { SecondaryHeader } from "@/components/SecondaryHeader";


export function PlayResponsiblyPage() {
    return (
        <div className="flex flex-col h-screen overflow-y-scroll pb-10 bg-white">
        <SafePaddingContainer orientation='header' className='bg-blue'>
            <SecondaryHeader text={'Play responsibly'} />
            {/* Main content */}
        </SafePaddingContainer>
        <SafePaddingContainer orientation='footer' className='bg-white'>
            <div className="p-4 max-w-md mx-auto mt-6">
                <div className='mb-8'>
                    <h2 className="text-3xl font-bold text-blue-dark mb-3">Play Responsibly</h2>
                    <p className="text-blue-dark mb-6 text-md">
                        At Scratch, we’re all about fun, skill, and fair play. 
                        Our games are designed for entertainment, and we want every player to enjoy them responsibly.
                    </p>
                </div>
                <div className='mb-8'>
                    <h2 className="text-xl font-bold text-blue-dark mb-2">Know your limits</h2>
                    <p className="text-blue-dark mb-6 text-md">
                        Playing should feel good—never stressful. 
                        If you ever feel like you're not in control, take a break. 
                        Set personal limits, and remember: it's just a game.
                    </p>
                </div>
                <div className='mb-8'>
                    <h2 className="text-xl font-bold text-blue-dark mb-2">Need help?</h2>
                    <p className="text-blue-dark mb-2 text-md">
                        If you're feeling overwhelmed or concerned, you're not alone. 
                        You can speak to someone anytime:
                    </p>
                    <p className="text-blue-dark mb-6 text-md">
                        Call 800-522-4700 or text 800GAM
                    </p>
                </div>
                <div className='mb-8'>
                    <h2 className="text-xl font-bold text-blue-dark mb-2">Take a break</h2>
                    <p className="text-blue-dark mb-6 text-md">
                        Want to self-exclude or set spending limits? 
                        Just email team@skillscratch.com, and we’ll take care of it – zero questions.
                    </p>
                </div>
                <div className='mb-8'>
                    <p className="text-blue-dark mb-6 text-md">
                        Thanks for playing smart, <br />
                        — The Scratch Team
                    </p>
                </div>
            </div>
        </SafePaddingContainer>
    </div>
    );
}